import { FormControl, Validators } from '@angular/forms';
import { EventEmitter, Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-release-all-dialog',
  templateUrl: './release-all-dialog.component.html',
  styleUrls: ['./release-all-dialog.component.scss']
})
export class ReleaseAllDialogComponent implements OnInit {
    releaseAllSelected = new EventEmitter<any>();
    dataReceived: any;
    title: string;
    id: string;
    type: string;

    thresholdControl = new FormControl('0', [Validators.required, Validators.min(0), Validators.max(100)]);
    reassign: boolean = false

    releaseCount: number = 0;
    reassignCount: number = 0;
    selectedReassignOption: boolean = true;
    subYes: boolean = false;
    subNo: boolean = false;

    constructor(
      public dialogRef: MatDialogRef<ReleaseAllDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data) {
        this.dataReceived = data.data;
        this.title = data.title;
        this.type = data.type;
    }

    ngOnInit(): void {
        this.onThresholdChange(0);
    }

    onThresholdChange = (thresholdValue) => {
        this.releaseCount = 0;
        this.reassignCount = 0;

        this.dataReceived.map(data => { 
            let grade = Number(data.Grade);
            if((data.Graded ?? (data.Grade != null)) && !data.GradeReleased && !isNaN(grade)) 
            {
                if(grade >= thresholdValue) {
                    this.releaseCount++;
                } else {
                    this.reassignCount++;
                }
            }
            else if(isNaN(grade) && data.Graded && !data.GradeReleased)
            {
                this.releaseCount++;
            }
        });
    }

    onReassignChange(event) {
        switch(event.value) {
            case true:
                this.subNo = false;
                break;
            case false:
                this.subYes = false;
                break;
        }
    }

    onRadioClicked = (event) => {
      event.stopPropagation();
    }

    onReleaseAll = () => {
        /////CAll API
        ////if success
        this.releaseAllSelected.emit({
            threshold: this.thresholdControl.value,
            reassign: this.reassign,
            reassignOption: this.selectedReassignOption,
            reassignSubOption: this.selectedReassignOption ? this.subYes : this.subNo
        });
        this.dialogRef.close();

        ///if failure
        /// CONFIRM LOGIC WITH DAVID
    }

    onCancel = () => {
      this.dialogRef.close();
    }

}
